import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

@Component({
  name: 'Hint',
})
export default class Hint extends Vue {
  @Prop({type: String, default: ''}) public readonly text!: string;
  @Prop({type: String, default: () => {}}) public readonly linkTo!: string;

  get isQuestion(): boolean {
    return this.text.includes('?');
  }

  private render(createElement: CreateElement): VNode {
    const question = this.isQuestion ? '?' : '';
    const text = this.isQuestion
      ? this.text.split('?')[0]
      : this.text.substring(0, this.text.lastIndexOf(' '));
    const linkName = this.text.split('?')[1] || this.text.split(' ').slice(-1);

    const link: VNode = createElement('router-link', {
      props: {
        to: { name: this.linkTo },
      },
      class: {
        'ml-1': true,
        'p3': true,
      },
      style: {
        'cursor': 'pointer',
        'border-bottom': '0.8px solid rgba(54, 53, 52, 0.4)',
      },
  }, linkName);


    return createElement('span', {
      style: {
        display: 'flex',
      },
    }, [
      createElement('p', {
        class: {
          'mb-0': true,
        },
        style: {
          color: '#828281',
        },
      },
      `${text}${question}`),
      link,
    ]);
  }
}
